import { GridColumnGroup } from '@mui/x-data-grid'

export const generateHeaderGroupStyles = (groups?: GridColumnGroup[]) => {
  const styles: Record<string, React.CSSProperties> = {}

  groups?.forEach((group: any) => {
    if (group.headerClassName && group.background) {
      styles[`& .${group.headerClassName}`] = {
        backgroundColor: `${group.background} !important`,
        borderRadius: '4px 4px 0px 0px',
        pointerEvents: 'none',
      }
    }
  })

  return styles
}
